import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ValueFirstOnboardingService } from '../../services/value-first-onboarding.service';
import { CampaignCurrency, VALUE_FIRST_CURRENCIES, VALUE_FIRST_INDUSTRIES } from '../../services/value-first-onboarding.types';

@Component({
  selector: 'vf-manual-step',
  templateUrl: './manual-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VfManualStep {
  readonly onboarding = inject(ValueFirstOnboardingService);
  readonly industries = VALUE_FIRST_INDUSTRIES;
  readonly currencies = VALUE_FIRST_CURRENCIES;
  readonly name = signal(this.onboarding.draft().brand?.name ?? '');
  readonly industry = signal(this.onboarding.draft().brand?.industry ?? '');

  onName(event: Event): void {
    this.name.set((event.target as HTMLInputElement).value);
    this.onboarding.clearError();
  }

  onIndustry(event: Event): void {
    this.industry.set((event.target as HTMLSelectElement).value);
    this.onboarding.clearError();
  }

  chooseCurrency(currency: CampaignCurrency): void {
    this.onboarding.setCurrency(currency);
  }

  submit(event: Event): void {
    event.preventDefault();
    this.onboarding.submitManual(this.name(), this.industry());
  }
}
